/**
 * SimpleGamePage - Test page for simplified 3D game
 */

import { GameProvider } from '../context/GameContext';
import SimpleGameWorld from '../components/game/SimpleGameWorld';

export default function SimpleGamePage() {
  return (
    <GameProvider>
      <SimpleGameWorld />
    </GameProvider>
  );
}
